// @ts-nocheck
import { AnyAction } from 'redux';
import {
  GET_POSTBACKS_CONVERSION_VALUE_MAPPING,
  GET_SK_AD_NETWORK_APPLICATION_STATUS,
  GET_TARGET_EVENTS_RECOMMENDATIONS,
  GET_CONVERSION_VALUE_MAPPING_RECOMMENDATION,
  SET_CURRENT_TARGET_EVENT,
  SET_CURRENT_CONVERSION_VALUE_MAPPING,
  UPDATE_SK_AD_NETWORK_APPLICATION_STATUS,
  UPDATE_CONVERSION_VALUE_MAPPING,
  SET_ASCENDING_ONLY,
  GET_MAPPING_TEMPLATES_OPTIONS,
  GET_MAPPING_TEMPLATE,
} from '../../actions/SKANPostbacksConversionMapping/SKANPostbacksConversionMappingActions';
import { reducerWrapper } from '../../support/utils';
import {
  ConversionValueTemplateOption,
  DashboardPostbackIndexMapping,
  TargetEventRecommendation,
} from '../../../../../shared/types/skadNetwork.types';

export type SKANPostbacksConversionMappingReducer = {
  mappingLoading: boolean;
  targetEventsLoading: boolean;
  processing: boolean;
  error: any;
  savedMapping: DashboardPostbackIndexMapping;
  currentMapping: DashboardPostbackIndexMapping;
  savedTargetEvent: string;
  currentTargetEvent: string;
  skAdNetworkEnabled: boolean;
  targetEventsRecommendations: TargetEventRecommendation[];
  skadnetworkRecommendationRevisionId?: string;
  savedAscendingOnly?: boolean;
  currentAscendingOnly?: boolean;
  templateOptions: ConversionValueTemplateOption[];
  activeTemplateId?: string;
  lastUpdate?: number;
};

export const INIT_STATE: SKANPostbacksConversionMappingReducer = {
  mappingLoading: true,
  targetEventsLoading: true,
  processing: false,
  error: null,
  savedMapping: {},
  currentMapping: {},
  savedTargetEvent: '',
  currentTargetEvent: '',
  skAdNetworkEnabled: null,
  targetEventsRecommendations: [],
  savedAscendingOnly: undefined,
  currentAscendingOnly: undefined,
  templateOptions: [],
  activeTemplateId: null,
  lastUpdate: null,
};

const Handler = (state: SKANPostbacksConversionMappingReducer, action: AnyAction) => {
  switch (action.type) {
    case GET_POSTBACKS_CONVERSION_VALUE_MAPPING.response:
      return {
        ...state,
        mappingLoading: false,
        savedMapping: action.data.mapping,
        savedTargetEvent: action.data.targetEvent,
        savedAscendingOnly: action.data.ascendingOnly,
        activeTemplateId: null,
        lastUpdate: action.data.lastUpdate,
      };
    case UPDATE_CONVERSION_VALUE_MAPPING.request:
      return {
        ...state,
        processing: true,
      };
    case UPDATE_CONVERSION_VALUE_MAPPING.response:
      const currentTime = Date.now();
      return {
        ...state,
        mappingLoading: false,
        processing: false,
        currentMapping: null,
        currentTargetEvent: '',
        currentAscendingOnly: null,
        savedMapping: action.data.mapping,
        savedTargetEvent: action.data.targetEvent,
        savedAscendingOnly: action.data.ascendingOnly,
        activeTemplateId: null,
        lastUpdate: currentTime,
      };
    case GET_SK_AD_NETWORK_APPLICATION_STATUS.response:
      return {
        ...state,
        mappingLoading: false,
        skAdNetworkEnabled: action.data.sk_ad_network_enabled,
      };
    case UPDATE_SK_AD_NETWORK_APPLICATION_STATUS.response:
      return {
        ...state,
        mappingLoading: false,
        skAdNetworkEnabled: action.data.skAdNetworkEnabled,
      };
    case GET_TARGET_EVENTS_RECOMMENDATIONS.request:
      return {
        ...state,
        targetEventsLoading: true,
      };
    case GET_TARGET_EVENTS_RECOMMENDATIONS.response:
      return {
        ...state,
        targetEventsLoading: false,
        targetEventsRecommendations: action.data || [],
      };
    case GET_CONVERSION_VALUE_MAPPING_RECOMMENDATION.request:
      return {
        ...state,
        processing: true,
      };
    case GET_CONVERSION_VALUE_MAPPING_RECOMMENDATION.response:
      return {
        ...state,
        mappingLoading: false,
        processing: false,
        currentMapping: action.data.mapping,
        skadnetworkRecommendationRevisionId: action.data.skadnetworkRecommendationRevisionId,
        activeTemplateId: null,
      };
    case SET_CURRENT_TARGET_EVENT.response:
      return {
        ...state,
        targetEventsLoading: false,
        currentTargetEvent: action.data,
      };
    case SET_CURRENT_CONVERSION_VALUE_MAPPING.response:
      return {
        ...state,
        mappingLoading: false,
        currentMapping: action.data,
        skadnetworkRecommendationRevisionId: null,
      };
    case SET_ASCENDING_ONLY.response:
      return {
        ...state,
        mappingLoading: false,
        currentAscendingOnly: action.data,
      };
    case GET_MAPPING_TEMPLATES_OPTIONS.response:
      return {
        ...state,
        processing: false,
        templateOptions: action.data,
      };
    case GET_MAPPING_TEMPLATE.request:
      return {
        ...state,
        processing: true,
      };
    case GET_MAPPING_TEMPLATE.response:
      return {
        ...state,
        processing: false,
        currentTargetEvent: '',
        currentMapping: action.data.mapping,
        activeTemplateId: action.data.id,
      };
    default:
      return state;
  }
};

const SKANPostbacksConversionMapping = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_POSTBACKS_CONVERSION_VALUE_MAPPING],
  error: [GET_POSTBACKS_CONVERSION_VALUE_MAPPING],
});

export default SKANPostbacksConversionMapping;
